"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgFlightWithMoon = function SvgFlightWithMoon(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#000",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.273 10a5 5 0 0 1 4.761-8.226 3.15 3.15 0 1 0 3.859 3.858 5.022 5.022 0 0 1 .083 1.53",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.694 11.49 5.79 12.66s-.505.393-1.458.196c-.954-.196-1.931-.412-1.931-.412s-.21-.077-.354.11c-.145.188.093.3.093.3l1.47 1.065s.314.31.775.229c.462-.082 1.82-.357 1.82-.357s.927-.198 2.03-.886c1.101-.688 5.041-3.08 5.041-3.08s1.534-.872 1.38-1.237c-.154-.365-1.038-.267-1.46-.133-.423.133-3.722 2.004-3.722 2.004l-3.616-1.24s-.468-.111-.234.162 2.525 2.554 2.525 2.554M9.045 13.232l.983.98s.285.226.342-.561c.058-.787.116-1.376.116-1.376"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgFlightWithMoon);
var _default = exports["default"] = Memo;